var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.audios.length)?_c('section',{staticClass:"player-audios"},_vm._l((_vm.audios),function(item,index){return _c('section',{key:index},[_c('custom-player',{attrs:{"audio":item,"index":index + 1,"description":index === 0 ? _vm.getCurrentLesson.content : ''}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }